import { render, staticRenderFns } from "./detail-test-input-entrance.vue?vue&type=template&id=0c74ddb4"
import script from "./detail-test-input-entrance.vue?vue&type=script&lang=js"
export * from "./detail-test-input-entrance.vue?vue&type=script&lang=js"
import style0 from "./detail-test-input-entrance.vue?vue&type=style&index=0&id=0c74ddb4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports